import { useState } from "react";

const TimezoneDropdown = ({ disabled = false }) => {
  const [selectedTimezone, setSelectedTimezone] = useState("");

  const timezones = [
    { city: "Berlin, Germany", offset: "GMT+1:00" },
    { city: "Belgrade, Serbia", offset: "GMT+1:00" },
    { city: "Belize City, Belize", offset: "GMT-6:00" },
    { city: "Birkirkara, Malta", offset: "GMT+1:00" },
    { city: "Bishkek, Kyrgyzstan", offset: "GMT+6:00" },
    { city: "Bissau, Guinea-Bissau", offset: "GMT+0:00" },
    { city: "Bogota, Colombia", offset: "GMT-5:00" },
    { city: "Boise, Idaho, United States", offset: "GMT-7:00" },
  ];

  const handleChange = (e) => {
    if (!disabled) {
      setSelectedTimezone(e.target.value);
    }
  };
  return (
    <div className="mb-3">
      <label className="form-label">Time shown in:</label>
      <select
        className={`form-select ${disabled ? "bg-light" : ""}`}
        value={selectedTimezone}
        onChange={handleChange}
        disabled={disabled}
        style={{
          padding: "10px",
          width: "100%",
          border: "none",
          borderRadius: "20px",
        }}
      >
        <option value="">Select a timezone</option>
        {timezones.map((tz, index) => (
          <option key={index} value={`${tz.city} (${tz.offset})`}>
            {tz.city} ({tz.offset})
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimezoneDropdown;
